// conversation - single conversation
import {
  GET_CONVERSATION,
  UPDATE_CONVERSATION_MESSAGES_REDUX_STATE,
  REMOVE_CONVERSATION_REDUX_STATE
} from '../actions/types'; // import the action type

const initialState = {
  unsubscribeToConversationListener: null,
  conversationListenerLoaded: false,
  messages: {},
  unsubscribeToMessagesListener: null,
  // every messages onSnapshot ever opened for this conversation. Each "Load
  // older messages" click opens another listener (they all merge into the one
  // messages map), so we must remember them all and tear them all down on
  // unmount — previously only the most recent unsubscribe was kept, leaking the
  // rest until a full reload.
  messagesListenerUnsubscribes: [],
  messagesListenerLoaded: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CONVERSATION: {
      return { ...state, ...action.payload.conversationObject };
    }
    case UPDATE_CONVERSATION_MESSAGES_REDUX_STATE: {
      const {
        messages,
        unsubscribeToMessagesListener,
        messagesListenerLoaded,
        convoMessagesFilter
      } = action.payload;

      // Accumulate distinct unsubscribes. This action re-fires on every snapshot
      // callback with the SAME unsubscribe reference, so dedupe by reference to
      // record each listener exactly once.
      const prevUnsubs = state.messagesListenerUnsubscribes || [];
      const messagesListenerUnsubscribes =
        typeof unsubscribeToMessagesListener === 'function' &&
        !prevUnsubs.includes(unsubscribeToMessagesListener)
          ? [...prevUnsubs, unsubscribeToMessagesListener]
          : prevUnsubs;

      return {
        ...state,
        messages,
        unsubscribeToMessagesListener,
        messagesListenerUnsubscribes,
        messagesListenerLoaded,
        convoMessagesFilter
      };
    }
    case REMOVE_CONVERSATION_REDUX_STATE: {
      return initialState;
    }
    default:
      return state;
  }
};
